import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import { IFilterModel, ISortOrderEnum } from 'shared/models/List'
import {
  BoardContactsSortFieldEnum,
  OtherContactsSortFieldEnum,
  ResidentContactsSortFieldEnum,
} from '../../models/Contacts'

export type ContactsList = 'residents' | 'others' | 'board'

const listFilters = (sortcolumn: string): IFilterModel => ({
  searchText: null,
  sortcolumn,
  sortorder: ISortOrderEnum.asc,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
})

const initialState: Record<ContactsList, IFilterModel> = {
  residents: listFilters(ResidentContactsSortFieldEnum.Name),
  others: listFilters(OtherContactsSortFieldEnum.Name),
  board: listFilters(BoardContactsSortFieldEnum.Name),
}

const contactsFiltersSlice = createSlice({
  name: 'contactsFilters',
  initialState,
  reducers: {
    patchContactsFilters: (
      state,
      {
        payload: { list, ...filters },
      }: PayloadAction<Partial<IFilterModel> & { list: ContactsList }>
    ) => ({ ...state, [list]: { ...state[list], ...filters } }),
    resetContactsFilters: () => initialState,
  },
})

export const getContactsFilters = (list: ContactsList) => (state: RootState) =>
  state.contactsFilters[list]

export const { patchContactsFilters, resetContactsFilters } =
  contactsFiltersSlice.actions

export default contactsFiltersSlice
